/**
 * Created by tofael on 3/23/17.
 */
module.exports={
  SET_USER:"SET_USER",
  DESTROY_USER:"DESTROY_USER",
  ASYNC_REQ_START:'ASYNC_REQ_START',
  ASYNC_REQ_END: 'ASYNC_REQ_END',
  NOTIFIY_USER: 'NOTIFIY_USER',
  RESET_FEEDBACKBAR:'RESET_FEEDBACKBAR'
}


// WEBPACK FOOTER //
// ./src/actions/types.js